import { ScholarshipPaymentDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */

export const loadScholarshipPayment = createAction(
  '[ScholarshipPayment] Load ScholarshipPayment',
  props<{ id: string }>()
);

export const loadScholarshipPaymentSuccess = createAction(
  '[ScholarshipPayment] Load ScholarshipPayment Success',
  props<{ scholarshipPayment: ScholarshipPaymentDto[] }>()
);

export const loadScholarshipPaymentFailure = createAction(
  '[ScholarshipPayment] Load ScholarshipPayment Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipPayment = createAction(
  '[ScholarshipPayment] Add ScholarshipPayment',
  props<{ newScholarshipPayment: ScholarshipPaymentDto }>()
);

export const addScholarshipPaymentSuccess = createAction(
  '[ScholarshipPayment] Add ScholarshipPayment Success',
  props<{ newScholarshipPayment: ScholarshipPaymentDto }>()
);

export const addScholarshipPaymentFailure = createAction(
  '[ScholarshipPayment] Add ScholarshipPayment Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchScholarshipPaymentRecord = createAction(
  '[ScholarshipPayment] Search  ScholarshipPayment Record',
  props<{ query: string }>()
);

/**
 * Update ScholarshipPayment Collection Actions
 */
export const updateScholarshipPayment = createAction(
  '[ScholarshipPayment] Update ScholarshipPayment',
  props<{ updateScholarshipPayment: ScholarshipPaymentDto }>()
);

export const updateScholarshipPaymentSuccess = createAction(
  '[ScholarshipPayment] Update ScholarshipPayment Success',
  props<{ updateScholarshipPayment: ScholarshipPaymentDto }>()
);

export const updateScholarshipPaymentFailure = createAction(
  '[ScholarshipPayment] Update ScholarshipPayment Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipPayment Collection Actions
 */
export const removeScholarshipPayment = createAction(
  '[ScholarshipPayment] Remove ScholarshipPayment',
  props<{ ids: string }>()
);

export const removeScholarshipPaymentSuccess = createAction(
  '[ScholarshipPayment] Remove ScholarshipPayment Success',
  props<{ ids: string }>()
);

export const removeScholarshipPaymentFailure = createAction(
  '[ScholarshipPayment] Remove ScholarshipPayment Failure',
  props<{ error: any }>()
);
